import type {
  ModalPreguntaRenovacionProps,
  UseModalPreguntaRenovacionReturn,
} from "./types";

export const useModalPreguntaRenovacion = ({
  setIsModalCreateClienteExistente,
  setIsModalPreguntaRenovacion,
}: ModalPreguntaRenovacionProps): UseModalPreguntaRenovacionReturn => {
  const handleClose = () => {
    setIsModalPreguntaRenovacion(false);
  };

  const renovarPrestamo = () => {
    handleClose();
    setIsModalCreateClienteExistente(true);
  };

  return {
    handleClose,
    renovarPrestamo,
  };
};
